// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminProfile {
  display: flex;
  position: relative;
}
.adminProfile .adminImage {
  position: relative;
  width: 40px;
  height: 40px;
  margin-left: 10px;
  cursor: pointer;
}
.adminProfile .adminImage img {
  object-fit: cover;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  width: 100%;
}
.adminProfile .adminImage::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(46, 175, 46);
  right: 0;
  bottom: 0;
  z-index: 5555;
}
.adminProfile .adminName {
  display: flex;
  flex-direction: column;
  text-align: end;
}
.adminProfile .adminName p {
  text-transform: capitalize;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 14px;
}
.adminProfile .adminName span {
  font-size: 12px;
}
.adminProfile .adminMenu {
  position: absolute;
  top: 60px;
  right: 0;
  width: 150px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid rgba(204, 204, 204, 0.397);
  box-shadow: 0 0 5px 0px rgba(204, 204, 204, 0.589);
  transition: 300ms;
  padding: 5px 0;
  z-index: 22;
}
.adminProfile .adminMenu button,
.adminProfile .adminMenu a {
  width: 100%;
  display: block;
  text-decoration: none;
  border: none;
  text-align: start;
  padding: 8px 10px;
  background-color: #fff;
  color: var(--mainFont);
  transition: 300ms;
  border-radius: 0;
  font-size: 14px;
}
.adminProfile .adminMenu button svg,
.adminProfile .adminMenu a svg {
  margin-right: 10px;
}
.adminProfile .adminMenu button:hover,
.adminProfile .adminMenu a:hover {
  background-color: #eaeaf0;
  color: #5b4eeb;
}
.adminProfile .adminMenu button:hover svg,
.adminProfile .adminMenu a:hover svg {
  color: #5b4eeb;
}
.adminProfile .enterMenu {
  opacity: 0;
  top: 75px;
}
.adminProfile .enterActiveMenu {
  opacity: 1;
  top: 60px;
}

.rtl .adminImage {
  margin-right: 10px;
}
.rtl .adminMenu {
  right: -30px !important;
}

.dark .adminMenu {
  background-color: var(--darkSecondColor) !important;
  border: 1px solid var(--darkSecondColor);
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);
}
.dark .adminMenu button,
.dark .adminMenu a {
  background-color: var(--darkSecondColor);
  color: var(--darkFont);
}
.dark .adminMenu button:hover,
.dark .adminMenu a:hover {
  background-color: rgba(122, 122, 253, 0.2039215686);
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Navbar/AdminProfile/adminProfile.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAEJ;AADI;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAGN;AAAE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAEJ;AADI;EACE,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAGN;AADI;EACE,eAAA;AAGN;AAAE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4CAAA;EACA,kDAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAEJ;AADI;;EAEE,WAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAGN;AAFM;;EACE,kBAAA;AAKR;AAFI;;EAEE,yBAAA;EACA,cAAA;AAIN;AAHM;;EACE,cAAA;AAMR;AAFE;EACE,UAAA;EACA,SAAA;AAIJ;AAFE;EACE,UAAA;EACA,SAAA;AAIJ;;AAAE;EACE,kBAAA;AAGJ;AADE;EACE,uBAAA;AAGJ;;AACE;EACE,mDAAA;EACA,wCAAA;EACA,4CAAA;AAEJ;AADI;;EAEE,wCAAA;EACA,sBAAA;AAGN;AADI;;EAEE,mDAAA;AAGN","sourcesContent":[".adminProfile {\n  display: flex;\n  position: relative;\n  .adminImage {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    margin-left: 10px;\n    cursor: pointer;\n    img {\n      object-fit: cover;\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      width: 100%;\n    }\n  }\n  .adminImage::after {\n    content: \"\";\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: rgb(46, 175, 46);\n    right: 0;\n    bottom: 0;\n    z-index: 5555;\n  }\n  .adminName {\n    display: flex;\n    flex-direction: column;\n    text-align: end;\n    p {\n      text-transform: capitalize;\n      margin-bottom: 0;\n      font-weight: bold;\n      font-size: 14px;\n    }\n    span {\n      font-size: 12px;\n    }\n  }\n  .adminMenu {\n    position: absolute;\n    top: 60px;\n    right: 0;\n    width: 150px;\n    background-color: #fff;\n    border-radius: 5px;\n    border: 1px solid rgba(204, 204, 204, 0.397);\n    box-shadow: 0 0 5px 0px rgba(204, 204, 204, 0.589);\n    transition: 300ms;\n    padding: 5px 0;\n    z-index: 22;\n    button,\n    a {\n      width: 100%;\n      display: block;\n      text-decoration: none;\n      border: none;\n      text-align: start;\n      padding: 8px 10px;\n      background-color: #fff;\n      color: var(--mainFont);\n      transition: 300ms;\n      border-radius: 0;\n      font-size: 14px;\n      svg {\n        margin-right: 10px;\n      }\n    }\n    button:hover,\n    a:hover {\n      background-color: #eaeaf0;\n      color: #5b4eeb;\n      svg {\n        color: #5b4eeb;\n      }\n    }\n  }\n  .enterMenu {\n    opacity: 0;\n    top: 75px;\n  }\n  .enterActiveMenu {\n    opacity: 1;\n    top: 60px;\n  }\n}\n.rtl {\n  .adminImage {\n    margin-right: 10px;\n  }\n  .adminMenu {\n    right: -30px !important;\n  }\n}\n.dark {\n  .adminMenu {\n    background-color: var(--darkSecondColor) !important;\n    border: 1px solid var(--darkSecondColor);\n    box-shadow: 0 4px 24px 0 rgb(0 0 0 / 24%);\n    button,\n    a {\n      background-color: var(--darkSecondColor);\n      color: var(--darkFont);\n    }\n    button:hover,\n    a:hover {\n      background-color: #7a7afd34;\n    }\n  }\n}\n// @media (max-width: 470px) {\n//   .adminProfile {\n//     .adminName {\n//       display: none;\n//     }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
